
import Slash from "../../../assets/filled/Slash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SlashIcon({ className, dataTestid = "SlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Slash data-testid={dataTestid} className={classes} {...rest} />
  );
}
